export type GoogleAddressType =
  | 'street_number'
  | 'route'
  | 'locality'
  | 'sublocality'
  | 'administrative_area_level_1'
  | 'administrative_area_level_3'
  | 'neighborhood'
  | 'postal_code';

export type AddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
};

export type ParsedAddressType = {
  street?: string;
  state?: string;
  city?: string;
  zipCode?: string;
};

export type PlaceAddressParts = ParsedAddressType;

export const parseAddress = (addressComponents: AddressComponent[]): ParsedAddressType => {
  const find = (field: GoogleAddressType, variant: 'long_name' | 'short_name' = 'long_name') =>
    addressComponents.find(c => c.types.find(t => t === field))?.[variant];

  const streetNumber = find('street_number');
  const streetName = find('route');
  return {
    street: streetNumber && streetName ? `${streetNumber} ${streetName}` : undefined,
    state: find('administrative_area_level_1', 'short_name'),
    city:
      find('locality') ||
      find('sublocality') ||
      find('administrative_area_level_3') ||
      find('neighborhood'),
    zipCode: find('postal_code'),
  };
};
